// @flow

import * as React from 'react';

import { Info } from 'lucide-react';

import { selectCartUUID, type ProductId } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { ListRow } from '../../../../ListRow';

export type Props = {
  productId: ProductId,
  authCode?: string,
};

export default function CodeRow({
  productId,
  authCode,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const cartId = useAppSelector(selectCartUUID);

  const listRowProps = authCode
    ? {
        cta: (
          <Button
            kind="link"
            to={`/cart/${cartId}/configure/${productId}/authinfo`}
          >
            {__('Change')}
          </Button>
        ),
        intent: 'muted',
      }
    : {
        cta: (
          <Button
            kind="link"
            to={`/cart/${cartId}/configure/${productId}/authinfo`}
          >
            {__('Add')}
          </Button>
        ),
        icon: <Info size={20} />,
        intent: 'warning',
      };

  return (
    <ListRow {...listRowProps}>
      {authCode
        ? __('Authorization Code: %(authCode)s', { authCode })
        : __('Missing authorization code')}
    </ListRow>
  );
}
